'use client'

import { withChunkErrorFallback } from '@/shared/ui'

import RankError from './_components/RankError'

interface IRankErrorBoundaryProps {
  error: Error & { digest?: string }
  reset: () => void
}

/** 랭킹 라우트 에러 바운더리 — Figma 8455:72663 */
const RankErrorBoundary = ({ reset }: IRankErrorBoundaryProps) => (
  <>
    {/* 에러 화면은 색인 대상에서 제외 (React 19가 <head>로 hoist) */}
    <meta name='robots' content='noindex' />
    <RankError onRetry={reset} />
  </>
)

export default withChunkErrorFallback(RankErrorBoundary, 'ModoocarRankPage')
